/** Meta líquida do dia (8h), alinhada ao backend. */
export const TC_NET_EXPECTED_MINUTES = 8 * 60;

/**
 * Saldo provisório do dia em aberto (entrada sem saída final).
 * Só para exibição (contador regressivo) — não altera banco de horas.
 * Espelha a lógica de computeNetWorkedMinutes do backend.
 */
export function computeLiveDayBalanceMinutes(opts: {
  checkInAt: string | null | undefined;
  checkOutAt?: string | null | undefined;
  lunchOutAt?: string | null | undefined;
  lunchInAt?: string | null | undefined;
  now?: Date;
}): number | null {
  if (!opts.checkInAt || opts.checkOutAt) return null;

  const now = opts.now ?? new Date();
  const checkIn = new Date(opts.checkInAt).getTime();
  if (Number.isNaN(checkIn)) return null;

  const asOf = now.getTime();
  let end = asOf;
  let lunchDeduction = 0;

  if (opts.lunchOutAt) {
    const lunchOut = new Date(opts.lunchOutAt).getTime();
    if (!Number.isNaN(lunchOut)) {
      if (opts.lunchInAt) {
        const lunchIn = new Date(opts.lunchInAt).getTime();
        if (!Number.isNaN(lunchIn) && lunchIn > lunchOut) {
          const deductStart = Math.max(checkIn, lunchOut);
          const deductEnd = Math.min(asOf, lunchIn);
          if (deductEnd > deductStart) {
            lunchDeduction = Math.round((deductEnd - deductStart) / 60000);
          }
        }
      } else {
        // No almoço: congela até a saída do almoço (sem desconto fixo ainda)
        end = Math.min(lunchOut, asOf);
      }
    }
  }

  const gross = Math.max(0, Math.round((end - checkIn) / 60000));
  const worked = Math.max(0, gross - lunchDeduction);
  return worked - TC_NET_EXPECTED_MINUTES;
}
